var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardArrowUpOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70175 14.7018L12.7018 9.70176C12.8947 9.52632 13 9.2807 13 9C13 8.45614 12.5439 8 12 8C11.7193 8 11.4737 8.10526 11.2982 8.29825L6.29825 13.2982C6.10526 13.4737 6 13.7193 6 14C6 14.5439 6.45614 15 7 15C7.2807 15 7.52632 14.8947 7.70175 14.7018ZM17.7018 13.2982L12.7018 8.29825C12.5263 8.10526 12.2807 8 12 8C11.4561 8 11 8.45614 11 9C11 9.2807 11.1053 9.52632 11.2982 9.70176L16.2982 14.7018C16.4737 14.8947 16.7193 15 17 15C17.5439 15 18 14.5439 18 14C18 13.7193 17.8947 13.4737 17.7018 13.2982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUpOutlined);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up_outlined.10e2d497.svg";
export { ForwardRef as ReactComponent };